import Header from 'components/headers/bulletins'
import LoansTabs from './tabs'

export default function RequestedLoans() {
    return (
        <>
            <Header title="وام های درخواستی" />
            <LoansTabs />
        </>
    )
}
